import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectMainComponent } from "../../../redux/slices/landingSlice";
import MainBasic from "./variants/MainBasic";

interface IMain {}

const Main = (props: IMain) => {
  const mainComponent = useSelector(selectMainComponent);
  return <MainBasic {...mainComponent} />;
};
export default Main;
